let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("4JM6n")]).then(() => parcelRequire('2L1tP'));